export const FETCH_CARE_ROUND = "app/CareRound/FETCH_CARE_ROUND";
export const FETCH_CARE_ROUND_SUCCESS =
  "app/CareRound/FETCH_CARE_ROUND_SUCCESS";
export const FETCH_CARE_ROUND_FAILURE =
  "app/CareRound/FETCH_CARE_ROUND_FAILURE";

export const ADD_CARE_ROUND = "app/CareRound/ADD_CARE_ROUND";
export const ADD_CARE_ROUND_SUCCESS = "app/CareRound/ADD_CARE_ROUND_SUCCESS";
export const ADD_CARE_ROUND_FAILURE = "app/CareRound/ADD_CARE_ROUND_FAILURE";

export const FETCH_CARE_ROUND_ITEM = "app/CareRound/FETCH_CARE_ROUND_ITEM";
export const FETCH_CARE_ROUND_ITEM_SUCCESS =
  "app/CareRound/FETCH_CARE_ROUND_ITEM_SUCCESS";
export const FETCH_CARE_ROUND_ITEM_FAILURE =
  "app/CareRound/FETCH_CARE_ROUND_ITEM_FAILURE";

export const FETCH_CARE_ROUND_REPORT = "app/CareRound/FETCH_CARE_ROUND_REPORT";
export const FETCH_CARE_ROUND_REPORT_SUCCESS =
  "app/CareRound/FETCH_CARE_ROUND_REPORT_SUCCESS";
export const FETCH_CARE_ROUND_REPORT_FAILURE =
  "app/CareRound/FETCH_CARE_ROUND_REPORT_FAILURE";

export const FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY =
  "app/CareRound/FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY";
export const FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY_SUCCESS =
  "app/CareRound/FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY_SUCCESS";
export const FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY_FAILURE =
  "app/CareRound/FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY_FAILURE";

export const FETCH_CARE_ROUND_OCCURRENCE_REPORT =
  "app/CareRound/FETCH_CARE_ROUND_OCCURRENCE_REPORT";
export const FETCH_CARE_ROUND_OCCURRENCE_REPORT_SUCCESS =
  "app/CareRound/FETCH_CARE_ROUND_OCCURRENCE_REPORT_SUCCESS";
export const FETCH_CARE_ROUND_OCCURRENCE_REPORT_FAILURE =
  "app/CareRound/FETCH_CARE_ROUND_OCCURRENCE_REPORT_FAILURE";

export const EDIT_CARE_ROUND = "app/CareRound/EDIT_CARE_ROUND";
export const EDIT_CARE_ROUND_SUCCESS = "app/CareRound/EDIT_CARE_ROUND_SUCCESS";
export const EDIT_CARE_ROUND_FAILURE = "app/CareRound/EDIT_CARE_ROUND_FAILURE";

export const DELETE_CARE_ROUND = "app/CareRound/DELETE_CARE_ROUND";
export const DELETE_CARE_ROUND_SUCCESS =
  "app/CareRound/DELETE_CARE_ROUND_SUCCESS";
export const DELETE_CARE_ROUND_FAILURE =
  "app/CareRound/DELETE_CARE_ROUND_FAILURE";

export const SET_CARE_ROUND_ADD_EDIT_MODAL =
  "app/CareRound/SET_CARE_ROUND_ADD_EDIT_MODAL";

export const FETCH_FACILITY_DAILY_REPORT =
  "app/CareRound/FETCH_FACILITY_DAILY_REPORT";
export const FETCH_FACILITY_DAILY_REPORT_SUCCESS =
  "app/CareRound/FETCH_FACILITY_DAILY_REPORT_SUCCESS";
export const FETCH_FACILITY_DAILY_REPORT_FAILURE =
  "app/CareRound/FETCH_FACILITY_DAILY_REPORT_FAILURE";

export const FETCH_FACILITY_TWICE_DAILY_REPORT =
  "app/CareRound/FETCH_FACILITY_TWICE_DAILY_REPORT";
export const FETCH_FACILITY_TWICE_DAILY_REPORT_SUCCESS =
  "app/CareRound/FETCH_FACILITY_TWICE_DAILY_REPORT_SUCCESS";
export const FETCH_FACILITY_TWICE_DAILY_REPORT_FAILURE =
  "app/CareRound/FETCH_FACILITY_TWICE_DAILY_REPORT_FAILURE";

export const FETCH_FACILITY_WEEKLY_REPORT =
  "app/CareRound/FETCH_FACILITY_WEEKLY_REPORT";
export const FETCH_FACILITY_WEEKLY_REPORT_SUCCESS =
  "app/CareRound/FETCH_FACILITY_WEEKLY_REPORT_SUCCESS";
export const FETCH_FACILITY_WEEKLY_REPORT_FAILURE =
  "app/CareRound/FETCH_FACILITY_WEEKLY_REPORT_FAILURE";

export const FETCH_FACILITY_INTERVAL_REPORT =
  "app/CareRound/FETCH_FACILITY_INTERVAL_REPORT";
export const FETCH_FACILITY_INTERVAL_REPORT_SUCCESS =
  "app/CareRound/FETCH_FACILITY_INTERVAL_REPORT_SUCCESS";
export const FETCH_FACILITY_INTERVAL_REPORT_FAILURE =
  "app/CareRound/FETCH_FACILITY_INTERVAL_REPORT_FAILURE";

export const MARK_ROUND_TASK_COMPLETION =
  "app/CareRound/MARK_ROUND_TASK_COMPLETION";
export const MARK_ROUND_TASK_COMPLETION_SUCCESS =
  "app/CareRound/MARK_ROUND_TASK_COMPLETION_SUCCESS";
export const MARK_ROUND_TASK_COMPLETION_FAILURE =
  "app/CareRound/MARK_ROUND_TASK_COMPLETION_FAILURE";

export const SAVE_ROUND_DATE_ASSIGNMENT =
  "app/CareRound/SAVE_ROUND_DATE_ASSIGNMENT";
export const SAVE_ROUND_DATE_ASSIGNMENT_SUCCESS =
  "app/CareRound/SAVE_ROUND_DATE_ASSIGNMENT_SUCCESS";
export const SAVE_ROUND_DATE_ASSIGNMENT_FAILURE =
  "app/CareRound/SAVE_ROUND_DATE_ASSIGNMENT_FAILURE";

export const FETCH_ROUND_ASSIGNMENT_SUMMARY =
  "app/CareRound/FETCH_ROUND_ASSIGNMENT_SUMMARY";
export const FETCH_ROUND_ASSIGNMENT_SUMMARY_SUCCESS =
  "app/CareRound/FETCH_ROUND_ASSIGNMENT_SUMMARY_SUCCESS";
export const FETCH_ROUND_ASSIGNMENT_SUMMARY_FAILURE =
  "app/CareRound/FETCH_ROUND_ASSIGNMENT_SUMMARY_FAILURE";
